export const apiUrl = 'https://www.stihl.com.tw:1337';

export const stihlTimelines = [
	{time: "1926", description: "由Andreas.Stihl 在德國斯圖加特附近一個小鎮創立，設計了第一台電動鏈鋸。"},
	{time: "1929", description: "創造了第一台STIHL雙人操作的鏈鋸。"},
	{time: "1931", description: "成為第一個出口鏈鋸到美國和俄羅斯的公司。"},
	{time: "1950", description: "製造世界上第一台單人操作的鏈鋸。"},
	{time: "1959", description: "製造出重量輕，使用方便的STIHL Contra鏈鋸，帶來鏈鋸市場的徹底變革。"},
	{time: "1971", description: "年產鏈鋸340,000台，成為全世界最大的鏈鋸製造商。"},
	{time: "1988", description: "製造世界上第一個用於二行程引擎的催化轉化器，可降低排放氣體中70%~ 80%的有害碳氫化合物。"},
	{time: "2002", description: "結合了二行程和四行程優點的混合油四行程引擎技術的應用，使引擎有害 排放更低，重量更輕，但輸出的扭力更大。"},
	{time: "Now", description: "STIHL已經成為全世界最廣泛被使用的鏈鋸品牌，同時因多年在鏈鋸設計 和製造上累積的經驗知識和專門技能，STIHL已逐步成為在如割草機、籬 笆剪和吹風機等其它園林動力工具領域的領導者。"}
];

export const googleMapApiKey = "AIzaSyACXo4XJd58p81stUOu62aPQDnEihDW-94";

export const googleAnalyticsId = "UA-119762908-1";

export default {
	apiUrl,
	stihlTimelines,
	googleMapApiKey,
	googleAnalyticsId
};


// WEBPACK FOOTER //
// ./src/config/config.js